import { render, staticRenderFns } from "./BoardRead.vue?vue&type=template&id=eac0822c"
import script from "./BoardRead.ts?vue&type=script&lang=ts&external"
export * from "./BoardRead.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardRead.vue?vue&type=style&index=0&id=eac0822c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports